import type { MutationTree } from 'vuex';
import type { VerifyLinkResponse } from '../../api/unversal-link/types/verify-link-response';
import type { RedirectURLError } from '../../api/unversal-link/types/redirect-url-error';
import type { UniversalLinkState } from './universal-link.types';
import { UniversalLinkMutation } from './universal-link.types';

export const mutations: MutationTree<UniversalLinkState> = {
  [UniversalLinkMutation.SetLoading](state: UniversalLinkState, loading: boolean) {
    state.loading = loading;
  },
  [UniversalLinkMutation.SetLoaded](state: UniversalLinkState, loaded: boolean) {
    state.loaded = loaded;
  },
  [UniversalLinkMutation.SetLoadingError](state: UniversalLinkState, loadingError: boolean) {
    state.loadingError = loadingError;
  },
  [UniversalLinkMutation.SetVerifyLinkResponse](
    state: UniversalLinkState,
    response: VerifyLinkResponse
  ) {
    state.verifyLinkResponse = response;
  },
  [UniversalLinkMutation.SetLoadingRedirectURL](state: UniversalLinkState, loading: boolean) {
    state.loadingRedirectURL = loading;
  },
  [UniversalLinkMutation.SetRedirectURL](state: UniversalLinkState, url: string) {
    state.redirectURL = url;
  },
  [UniversalLinkMutation.SetRedirectURLError](state: UniversalLinkState, error: RedirectURLError) {
    state.redirectURLError = error;
  },
};
